module.exports = "/images/easter_island.svg?91a1eb16d90ba2c6ba178038ca75abb1";